import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type State = {
  baseUrl: string;
  isSocial: boolean;
  isProfilePageInstalled: boolean;
  showPublicSections: boolean;
};

export const siteSlice = createSlice({
  name: 'site',
  initialState: {
    baseUrl: '',
    isSocial: false,
    isProfilePageInstalled: false,
    showPublicSections: false,
  },
  reducers: {
    setBaseUrl(state, { payload }: PayloadAction<string>) {
      state.baseUrl = payload;
    },
  },
});
